import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { UsanaTranslationsModule } from '@usana/ux/translations';
import { AssociateSearchModule } from '../associate-search/associate-search.module';
import { SafePipe } from '../common/safe.pipe';
import { TrimPipe } from '../common/trim.pipe';
import { CcpaComponent } from './ccpa/ccpa.component';
import { DotcomModalComponent } from './dotcom-modal/dotcom-modal.component';
import { DotcomFooterComponent } from './dotcom-footer.component';
import { AppLinkDirective } from '../../modules/common/app-link.directive';
import { TranslateComponent } from '../../modules/translation/translate.component';

@NgModule({
    declarations: [DotcomFooterComponent, CcpaComponent, DotcomModalComponent],
    imports: [
        CommonModule,
        UsanaTranslationsModule,
        TrimPipe,
        SafePipe,
        AppLinkDirective,
        AssociateSearchModule,
        NgbCollapseModule,
        NgbModalModule,
        TranslateComponent,
    ],
    exports: [DotcomFooterComponent],
})
export class DotcomFooterModule {}
